import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { statusSchedule } from '../../view-agenda/view-agenda.component';
import { LoadingModalComponent } from "../../../../../loading-modal/loading-modal.component";
import { AgendaService } from '../../services/agenda.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertComponent } from '../../../../../alert/alert.component';
import moment from 'moment';

@Component({
  selector: 'app-remarcar-agendamento',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, LoadingModalComponent, AlertComponent],
  providers: [DatePipe],
  templateUrl: './remarcar-agendamento.component.html',
  styleUrls: ['./remarcar-agendamento.component.scss'],
})
export class RemarcarAgendamentoComponent  implements OnInit {
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @Input() objectRefAppointment: any;
  public copyObjectRefAppointment: any;


  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() updateAppointment: EventEmitter<void> = new EventEmitter<void>();

  public formReeschedule!: Object;
  public dateAppointment: boolean =  false;
  public statusSchedule = statusSchedule;
  public dateSelected!: string;
  public dateForm!: string;
  public avaliableTimes!: string[];

  constructor(private readonly scheduleService: AgendaService, private datePipe: DatePipe, private readonly router: Router) { 

  }

  ngOnInit() {
    this.copyObjectRefAppointment = {
      ...this.objectRefAppointment
    }
  }

  handleCloseModal(){
    this.closeModal.emit();
  }

  /**
   * This function execute request hours free in date selected
   */
  handleShowDate(){
    this.loadingComponent.activeLoading();

    this.dateSelected  = (this.datePipe.transform(this.dateForm, 'yyyy-MM-dd') as string);
    this.scheduleService.getAvaliableTimes(this.dateSelected, this.objectRefAppointment.scheduleId).subscribe((response: any)=> {
      console.log("Resposta: ", response);
      this.dateAppointment = true;
        this.avaliableTimes = response;
        console.log("Horarios disponiveis: ", this.avaliableTimes);
        this.copyObjectRefAppointment.date = this.dateSelected;
        this.loadingComponent.inactiveLoading();
    }, (error: any)=> {
      if(error as Error){
        if(error as HttpErrorResponse){
          if(error.status === 401){
            this.router.navigate(['/login']);
          }

          if(error.status === 400){
            console.log(" Horario indisponivel");
            this.loadingComponent.inactiveLoading();
          }
        }
      }
    })
  }

  getStatusEnum(status: keyof typeof statusSchedule): string{
        return this.statusSchedule[status];
  }

  handleSubmitReeschedule(){
    this.loadingComponent.activeLoading();
    this.scheduleService.createAppointmentReeschedule(this.copyObjectRefAppointment).subscribe((response: any)=> {
      this.alertComponent.showAlert('Agendamento remarcado com sucesso!','success');
      this.loadingComponent.inactiveLoading();
      this.updateAppointment.emit();
      this.closeModal.emit();
      
    },(error: any)=> {
      console.log(error);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(error.message,  'error');
    })
  }

}
